// The month view's title row: "October 2026". It was upper-cased ("OCTOBER 2026"); the design rules have no
// all-caps eyebrows, so the label keeps the locale's own casing.
export function formatMonthLabel(date: Date): string {
  return date.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
}
